@if (isLoaded) {
  @if (!isReadOnlyMode) {
    <rt-note-form
      [active]="state.notesBeingEdited.includes(NEW_NOTE_ID)"
      [note]="$any({ id: NEW_NOTE_ID })"
      [placeholder]="'app.requisitions.notes.placeholder' | translate"
      [autosave]="false"
      [noteSaveLoading]="state.notesBeingSaved && state.notesBeingSaved.includes(NEW_NOTE_ID)"
      [attachmentLoading]="
        state.noteAttachmentsBeingUploaded[NEW_NOTE_ID]
          ? !!state.noteAttachmentsBeingUploaded[NEW_NOTE_ID].length
          : false
      "
      [attachmentsTemp]="state.noteAttachmentsTemp && state.noteAttachmentsTemp[NEW_NOTE_ID]"
      [canDeleteAttachments]="true"
      [admins]="users"
      (noteSaveClick)="noteSaveClick($any($event))"
      (cancelClick)="noteDiscardClick($event)"
      (noteEditClick)="noteEditClick($event)"
      (uploadAttachmentClick)="uploadAttachmentClick($any($event))"
      (deleteAttachmentClick)="deleteAttachmentClick($event)"
      (typingStart)="handleNoteTypingStart({ replyToId: undefined })"
      (typingFinish)="handleNoteTypingFinish()"
      margin-bottom
    >
    </rt-note-form>
  }
  <rt-notes-list
    [notes]="state.notes.data!"
    [notesBeingEdited]="state.notesBeingEdited"
    [notesBeingRepliedTo]="state.notesBeingRepliedTo"
    [canHighLevelDataAccess]="hasHighLevelDataAccess"
    [currentAdmin]="currentUser"
    [currentlyTypedNotes]="currentlyTypedNotes"
    [notesBeingSaved]="state.notesBeingSaved"
    [notesBeingDeleted]="state.notesBeingDeleted"
    [noteAttachmentsTemp]="state.noteAttachmentsTemp"
    [noteAttachmentsBeingUploaded]="state.noteAttachmentsBeingUploaded"
    [adminsList]="users"
    [canDeleteAttachments]="true"
    [isReadOnly]="isReadOnlyMode"
    (noteSaveClick)="noteSaveClick($any($event))"
    (noteChecklistClick)="noteChecklistClick($event)"
    (noteDeleteClick)="noteDeleteClick($event)"
    (notePinClick)="notePinClick($any($event))"
    (noteUnpinClick)="noteUnpinClick($any($event))"
    (noteEditClick)="noteEditClick($event)"
    (noteReplyClick)="noteReplyClick($any($event))"
    (noteDiscardClick)="noteDiscardClick($any($event))"
    (uploadAttachmentClick)="uploadAttachmentClick($any($event))"
    (deleteAttachmentClick)="deleteAttachmentClick($any($event))"
    (replyTypingStart)="handleNoteTypingStart($event)"
    (replyTypingFinish)="handleNoteTypingFinish()"
  >
  </rt-notes-list>

  @if (!state.notes.data?.length) {
    <rt-empty-state
      [icon]="'comment'"
      [title]="'app.requisitions.notes.empty_state.title' | translate"
      [desc]="'app.requisitions.notes.empty_state.description' | translate"
      variant="default"
    >
    </rt-empty-state>
  }
} @else {
  <rt-spinner></rt-spinner>
}
